export default "__VITE_ASSET__e2ed3d8c__"